import { FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { getConfig, TranslationWithNum } from 'src/app/i18n';
import { useStyles } from './exam-session-selection.style';
import { useTranslation } from '@pruforce/common-adminweb-sdk';
import { RegistrationExamDropdownItem } from 'src/app/modules/Recruitment/types/license-exam-types';

interface ExamSessionFiltersProps {
  sessionCount: number;
  yearOptions: RegistrationExamDropdownItem[];
  monthOptions: number[];
  selectedYear: number | '';
  selectedMonth: number | '';
  loading: boolean;
  onYearChange: (year: number) => void;
  onMonthChange: (month: number) => void;
}

export const ExamSessionFilters = ({
  sessionCount,
  yearOptions,
  monthOptions,
  selectedYear,
  selectedMonth,
  loading,
  onYearChange,
  onMonthChange,
}: ExamSessionFiltersProps) => {

  const lang = getConfig().selectedLang;
  const t = useTranslation();
  const { classes } = useStyles();

  return (
    <Grid container spacing={1.5} alignItems="center">
      <Grid item xs={3}>
        <Typography className={classes.sessionCount}>
          {TranslationWithNum(
            'recruitment.exam.registration.adminRegistration.sessionSelection.sessionCount',
            sessionCount,
          )}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <FormControl size="small" fullWidth>
              <InputLabel id="exam-session-year-label">
                {t('recruitment.exam.registration.adminRegistration.sessionSelection.year')}
              </InputLabel>
              <Select
                labelId="exam-session-year-label"
                value={selectedYear}
                disabled={loading}
                label={t('recruitment.exam.registration.adminRegistration.sessionSelection.year')}
                onChange={(event) => onYearChange(Number(event.target.value))}
              >
                {yearOptions.map(({ year }) => (
                  <MenuItem key={year} value={year}>{year}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl size="small" fullWidth>
              <InputLabel id="exam-session-month-label">
                {t('recruitment.exam.registration.adminRegistration.sessionSelection.month')}
              </InputLabel>
              <Select
                labelId="exam-session-month-label"
                value={selectedMonth}
                disabled={loading}
                label={t('recruitment.exam.registration.adminRegistration.sessionSelection.month')}
                onChange={(event) => onMonthChange(Number(event.target.value))}
              >
                {monthOptions.map((month) => (
                  <MenuItem key={month} value={month}>
                    {lang === 'en' ? t(`Common.month_${month}`) : t('Common.month', { month })}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={3} />
    </Grid>
  );
};
